export enum Feature {
  BypassIdCapture = 'BypassIdCapture',
  VideoFeedInSigningRoom = 'VideoFeedInSigningRoom',
}
